import { forwardRef } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const inputVariants = cva(
  'flex w-full rounded-md border px-3 py-2 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'border-border bg-input text-foreground focus-visible:ring-ring',
        error: 'border-danger bg-input text-foreground focus-visible:ring-danger',
        success: 'border-success bg-input text-foreground focus-visible:ring-success',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'>,
    VariantProps<typeof inputVariants> {
  error?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ variant, error, className, autoComplete, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={cn(inputVariants({ variant: error ? 'error' : variant }), className)}
        autoComplete={autoComplete ?? 'off'}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';
